import React, { useState } from 'react';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { Explanations } from '../../../../components/Explanations/Explanations';
import { EstatePlanningTab } from '../../EstatePlanning.types';
import { BeneficiariesActions } from './components/BeneficiariesActions/BeneficiariesActions';
import { AssetType, SelectedAsset } from './Beneficiaries.meta';
import { OtherAssets } from './components/OtherAssets/OtherAssets';
import { useBeneficiaries } from './useBeneficiaries';
import { Accounts } from './components/Accounts/Accounts';
import { EquityCompensation } from './components/EquityCompensation/EquityCompensation';
import { Loading } from '../../../../../../CommonComponents/OPL/Loading/Loading';
import { Tasks } from '../../../../components/Tasks/Tasks';
import { useRouteParams } from '../../../../hooks/useRouteParams';
import { useDocumentTitle } from '../../../../../../_hooks/useDocumentTitle';

export const Beneficiaries = () => {
  useDocumentTitle('Goals - Estate Planning Beneficiaries');

  const [filterAssetType, setFilterAssetType] = useState<SelectedAsset>({
    assetType: AssetType.Accounts,
    isSimulated: false,
  });

  const { data, isLoading } = useBeneficiaries();

  const { goalId } = useRouteParams();

  if (isLoading) {
    return (
      <Box my="56">
        <Loading text="Loading..." mx="auto" />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  const { Simulated, Current } = data;

  const assetData = filterAssetType.isSimulated ? Simulated : Current;
  const { Accounts: accountsData, OtherAssets: otherAssetsData } = assetData;

  const assetTypesList = [
    { name: 'Account', assetType: AssetType.Accounts },
    { name: 'Other Assets', assetType: AssetType.OtherAssets },
    ...(Current.EquityCompensations.length > 0
      ? [{ name: 'Equity Compensation', assetType: AssetType.EquityCompensation }]
      : []),
  ];

  return (
    <>
      <Box mb="32">
        <Explanations selectedTab={EstatePlanningTab.Beneficiaries} my="24" />

        <BeneficiariesActions
          assetTypesList={assetTypesList}
          filterAssetType={filterAssetType}
          setFilterAssetType={setFilterAssetType}
        />

        <Box mt="24">
          {filterAssetType.assetType === AssetType.Accounts && (
            <Accounts
              key={filterAssetType.isSimulated ? 'current' : 'simulated'}
              data={accountsData}
              isSimulation={filterAssetType.isSimulated}
            />
          )}

          {filterAssetType.assetType === AssetType.OtherAssets && (
            <OtherAssets
              key={filterAssetType.isSimulated ? 'current' : 'simulated'}
              data={otherAssetsData}
              isSimulation={filterAssetType.isSimulated}
            />
          )}

          {filterAssetType.assetType === AssetType.EquityCompensation &&
            Current.EquityCompensations.length > 0 && (
              <EquityCompensation data={Current.EquityCompensations} />
            )}
        </Box>
      </Box>

      <Tasks goalId={goalId} />
    </>
  );
};
